export default __webpack_public_path__ + "static/char-50-anr-24a3c0c6167ca88704e0fe73d3817a35.gif";